import module from './store'
import Manager from './AudienceHub'
import { createStoreConnector } from '@/store'

export const AudienceHub = createStoreConnector('targetManager', module, {})(Manager)



// WEBPACK FOOTER //
// ./src/app/views/audienceHub/index.js